(function() {
  console.log('Info modal script loaded from external file');
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInfoModal);
  } else {
    initInfoModal();
  }
  
  function initInfoModal() {
    console.log('Initializing info modal');
    
    // Get the modal element
    const modal = document.getElementById('info-modal');
    if (!modal) {
      console.error('Info modal element not found');
      return;
    }
    
    // Function to open the modal
    function openModal() {
      console.log('Opening modal');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    
    // Function to close the modal
    function closeModal() {
      console.log('Closing modal');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    
    // Close modal when clicking on overlay or close button
    const closeElements = modal.querySelectorAll('[data-close]');
    closeElements.forEach(el => {
      el.addEventListener('click', function(event) {
        closeModal();
      });
    });
    
    // Close modal on escape key press
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    });
    
    // Attach click event to all elements with data-info-modal attribute
    function attachTriggers() {
      const triggers = document.querySelectorAll('[data-info-modal]');
      console.log('Found info modal triggers:', triggers.length);
      
      triggers.forEach(trigger => {
        console.log('Adding click listener to trigger:', trigger);
        trigger.addEventListener('click', function(event) {
          event.preventDefault();
          console.log('Trigger clicked');
          openModal();
        });
      });
    }
    
    // Make the open function globally available
    window.openInfoModal = openModal;
    
    // Attach triggers
    attachTriggers();
    
    // Also attach triggers after window load (in case some elements are added dynamically)
    window.addEventListener('load', attachTriggers);
  }
})(); 